export default function ApplicationFacet({
  handleFilterClick,
  productApplications,
}) {
  function sortObject(obj) {
    return Object.keys(obj)
      .sort()
      .reduce((a, v) => {
        a[v] = obj[v];
        return a;
      }, {});
  }
  productApplications = sortObject(productApplications);
  const wpProductCategory = window.wpProductCategory;
  const plpFacetLabel = wpProductCategory.plpFacetLabel;
  const title =
    plpFacetLabel &&
    Object.keys(plpFacetLabel)?.length > 0 &&
    plpFacetLabel.hasOwnProperty("application_facet") &&
    plpFacetLabel.application_facet != ""
      ? plpFacetLabel.application_facet
      : "Application";
  return (
    <div class="facet-wrap facet-display">
      <strong>{title}</strong>
      <div className="facetwp-facet">
        {Object.keys(productApplications).map((application, i) => {
          if (application && productApplications[application] > 0) {
            return (
              <div>
                <span
                  id={`application-filter-${i}`}
                  key={i}
                  data-value={`${application.toLowerCase()}`}
                  onClick={(e) =>
                    handleFilterClick(
                      "application_facet",
                      e.target.dataset.value
                    )
                  }>
                  {" "}
                  {application} {` (${productApplications[application]}) `}
                </span>
              </div>
            );
          }
          return null;
        })}
      </div>
    </div>
  );
}
